import { Link } from "react-router-dom";

export const LogoMark = ({ className = "w-10 h-10" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <circle cx="24" cy="24" r="22" fill="#0B2216" stroke="#D4A359" strokeWidth="1.5" />
    <circle cx="24" cy="24" r="17" fill="none" stroke="#D4A359" strokeOpacity="0.35" strokeWidth="0.75" strokeDasharray="1.5 2.5" />
    <path d="M24 8 L28.5 24 L19.5 24 Z" fill="none" stroke="#F7F4EB" strokeWidth="1.2" strokeLinejoin="round" />
    <path d="M19.5 24 L28.5 24 L24 41 Z" fill="#C85A32" />
    <circle cx="24" cy="24" r="1.8" fill="#D4A359" />
  </svg>
);

export const Logo = ({ testId = "site-logo" }) => (
  <Link to="/" data-testid={testId} className="group flex items-center gap-3" aria-label="CAP SUD — accueil">
    <LogoMark className="w-10 h-10 transition-transform duration-700 group-hover:rotate-180" />
    <span className="leading-none whitespace-nowrap">
      <span className="font-display block text-xl tracking-[0.08em] text-[#F7F4EB]">CAP SUD</span>
      <span className="block text-[10px] uppercase tracking-[0.3em] text-[#D4A359] mt-1">Morangis</span>
    </span>
  </Link>
);
